import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { tap } from 'rxjs/internal/operators/tap';
import { Observable } from 'rxjs/internal/Observable';

import { HttpHeader } from '../constants/app.constant';
import { SessionStorageService } from 'ngx-webstorage';
import { CacheConstant } from '../cache/cache.constant';
import { Environment } from '../environment/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  /*********************Constructor*********************/
  constructor(private sessionStorage: SessionStorageService) { }
  /*********************Constructor*********************/

  /*********************Implementation Methods*********************/

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Clone the request to add authorization token in header.
    let token = null;
    
    const cloneRequest = request.clone({
      setHeaders: this.setAuthTokenHeader(request.headers, request)
    });

    // Pass on the cloned request instead of the original request.
    return next.handle(cloneRequest).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.verifyAuthToken(event);
        }
      })
    );

  }

  /*********************Implementation Methods*********************/

  /*********************Private Methods*********************/

  /**
   * Set authorization token for every http requests
   * @param headers Default Http Headers
   */
  private setAuthTokenHeader(headers: HttpHeaders, request: HttpRequest<any>) {
    const requestHeaders: any = {};
    let token = null;
    let refreshToken=null;
    let accessToken = null;
    let idToken = null;
    let isAccountCall = (request.url.trim().indexOf('/account') >= 0) ? true : false;
    let isAccountChangeCall = (request.url.trim().indexOf('/accountChange?') >= 0) ? true : false;
    let url = window.location.href;
    token = this.sessionStorage.retrieve(CacheConstant.SessionStorageData.AuthenticationToken);
    accessToken = this.sessionStorage.retrieve(CacheConstant.SessionStorageData.AccessToken);
    idToken = this.sessionStorage.retrieve(CacheConstant.SessionStorageData.IdToken);
    refreshToken = this.sessionStorage.retrieve(CacheConstant.SessionStorageData.RefreshToken);
    if (url.includes('AUTH_TOKEN')) {
     
      const httpparams = new HttpParams({ fromString: url.split('AUTH_TOKEN')[1] });
      token = "Bearer " + httpparams.get('');
      accessToken =  httpparams.get('ACCESS_TOKEN');
      idToken = httpparams.get('ID_TOKEN');
      refreshToken=httpparams.get('REFRESH_TOKEN');
      this.sessionStorage.store(CacheConstant.SessionStorageData.AuthAccessToken, httpparams.get(''));
      this.sessionStorage.store(CacheConstant.SessionStorageData.AccessToken, accessToken);
      this.sessionStorage.store(CacheConstant.SessionStorageData.IdToken, idToken);
      this.sessionStorage.store(CacheConstant.SessionStorageData.RefreshToken, refreshToken);
    }
    const shipTO = this.sessionStorage.retrieve(CacheConstant.SessionStorageData.ShipTo);
    if (shipTO != null && !request.url.includes('jwtforoktab2b')) {
      requestHeaders[HttpHeader.CustomerShipTo] = btoa(shipTO);
       requestHeaders[HttpHeader.loginShipToNumber]=shipTO.toString();
    }

   
    if (token) {
      requestHeaders.Authorization = token;
    }
    if (isAccountCall || isAccountChangeCall) {

      requestHeaders['okta-access-token'] ="Bearer " + accessToken;
      requestHeaders['okta-id-token'] = "Bearer " + idToken;

    }
    
    
    requestHeaders['x-api-key'] = Environment.getInstance().appConfig.apiKey;
    headers.append(HttpHeader.CustomerShipTo, btoa(this.sessionStorage.retrieve(CacheConstant.SessionStorageData.ShipTo)));
    if (headers.keys().length > 0) {
      headers.keys().forEach(key => {
        requestHeaders[key] = headers.get(key);
      });
    }
    return requestHeaders;
  }

  /**
   * Check for updated authorization token for every http response and update in cache.
   * @param response Http Service Response
   */
  private verifyAuthToken(response: HttpResponse<any>) {
   
  }

  /*********************Private Methods*********************/
}
